// @flow

export const meetingTypes = {
  ACTUALLY: 10,
  WRITTEN: 20,
};
